<template>
  <div class="editor-page-list">
    <el-col class="search-wrapper">
      <el-input clearable size="medium" style="font-size: 13px;" placeholder="请输入页面标题" class="search-page"
                v-model="name_like">
        <el-button slot="append" @click="searchPage()">搜索</el-button>
      </el-input>
    </el-col>

    <div class="page-list" :style="'padding-top: 20px;'">
      <el-collapse v-model="activeNames" :accordion='false' @change="handleChange">
        <el-collapse-item v-for="(group,gIndex) in groupList" :name="gIndex" :key="gIndex">
          <el-col align="center">
            <el-button class="add-page" @click="addPage(gIndex)">
              <i class="el-icon-plus"></i>新建页面
            </el-button>
          </el-col>
          <el-tooltip class="item" effect="dark" placement="right" v-for="(page,pIndex) in group.pageList" :key="pIndex"
                      :manual="!(page.update_hint === 1 || (page.update_hint === 0 && page.status === 1))">
            <div slot="content" class="tip">
              <span>已保存但未发布</span>
            </div>
            <div class="page-item" @click="changePage(pIndex,gIndex)"
                 :class="[seleIndex === gIndex && pIndex === currentEditPageIndex ? 'active' : '']" type="flex"
                 justify="space-between">
              <div class="un-publish"
                   v-if="page.update_hint === 1 || (page.update_hint === 0 && page.status === 1)"></div>
              <el-col style="display:flex;align-items: center;" :span="page.is_home_page === 1 ? 20 : 16">
                <span :class="page.is_home_page === 1 ? 'nameCls1' : 'nameCls2'">{{ page.name || '页面名称' }}</span>
              </el-col>
              <el-col class="set-icon" :span="12">
                <el-tooltip class="item" effect="dark" content="共享页面" placement="top">
                  <i class="icon-tms-edit iconfont" v-if="page.page_id" @click.stop.prevent="sharePage(page)">&#xe637;</i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="复制页面" placement="top">
                  <i class="icon-tms-copy iconfont" v-if="page.page_id" @click.stop.prevent="copyPage(page)">&#xe6c1;</i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除页面" placement="top">
                  <i class="icon-tms-delete iconfont" @click.stop.prevent="delConfirm(page.page_id, pIndex,gIndex)">&#xe603;</i>
                </el-tooltip>
              </el-col>
            </div>
          </el-tooltip>
        </el-collapse-item>
      </el-collapse>
    </div>

    <div class="block" style="padding-top: 25px">
      <el-pagination
          small
          background
          :current-page="page"
          :page-size="15"
          @current-change="handleCurrentChange"
          layout="prev,next,jumper"
          :total="50000">
      </el-pagination>
    </div>


    <el-dialog title="请选择共享人" :visible.sync="dialog.visible" @close='closeDialog'>
      <div class="dialog-tips">提示：只能共享10人，不支持多人同时在线编辑同一页面。</div>
      <div class="dialog-select">
        已共享(<b>{{addList.split(',').length-1}}</b>)人
        <div v-if="addList && addList.split(',').length>1">
          <span v-for="(tel,index) in addList.split(',')">
            <span v-if="tel != myCount">
              {{tel.replace(tel.substring(3,7), "****")}},
            </span>
          </span>
        </div>
      </div>
      <el-form :inline="true"  label-width="80px" :model="formInline" class="demo-form-inline">
        <el-form-item  label="用户名称">
          <el-input v-model="formInline.nickname" placeholder="用户名称"></el-input>
        </el-form-item>
        <el-form-item  label="用户账号">
          <el-input v-model="formInline.phoneNumber" placeholder="用户账号(手机号)"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getUserList">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="dialog-content">
        <el-table
            :data="userList"
            border
            style="width: 100%">
          <el-table-column
              prop="nickname"
              label="用户名称">
          </el-table-column>

          <el-table-column
              label="操作"
              width="120">
            <template slot-scope="scope">
              <el-button v-show="addList.indexOf(scope.row.phoneNumber) == -1" @click="addUser(scope.row.phoneNumber)" type="text" size="small">选择共享</el-button>
              <span>
                <el-button v-show="addList.indexOf(scope.row.phoneNumber) > -1" @click="removeUser(scope.row.phoneNumber)" type="text" size="small">取消共享</el-button>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Vue from 'vue';

export default {
  props: {
    pageList: {
      type: Array,
      default: [],
    },
    pageData: {
      type: Object,
      default: {},
    },
    originData: {
      type: String,
      default: '',
    },
    groupList: {
      type: Array,
      default: [],
    },
    groupIndex: {
      type: Number,
      default: 0,
    },
    page: {
      type: Number,
      default: 1,
    },
    pageIndex: {
      type: Number,
      default: 0,
    },
    groupIndexList: {
      type: Array,
      default: [0],
    },
    currentEditPageIndex: '',
  },

  data() {
    return {
      name_like: '',
      radio: '',
      checked: false,
      activeNames: this.groupIndexList,
      seleIndex: 0,
      dialog: {
        visible: false
      },
      userList: [],
      addList:'',
      formInline:{
        nickname:'',
        phoneNumber:''
      },
      myCount:lib.cookie.get('mobile')
    };
  },
  watch: {
    pageList: function (newPageList, oldPageList) {
      this.pageList = newPageList;
      var checked = true;
      this.pageList.forEach(element => {
        if (!element.isSelect) {
          checked = false;
        }
      });
      this.checked = checked;
    },

    groupList: function (newGroupList, oldGroupList) {
      this.groupList = newGroupList;
    },
    groupIndex: function (newGroupIndex, oldGroupIndex) {
      this.seleIndex = newGroupIndex;
    },
  },
  methods: {
    addUser(val){
      if(this.addList && this.addList.split(',').length>10){
        this.$message.error("最多共享10人!");
        return;
      }
      this.addList = this.addList+','+val;
      this.updatePageShare();
    },
    removeUser(val){
      if(val == this.myCount){
        this.$message.error("不能取消共享自己!");
        return;
      }
      this.addList = this.addList.replace(','+val,'')
      this.updatePageShare();
    },
    closeDialog(){
      this.dialog.visible = false;
    },
    // 共享页面
    sharePage(item) {
      this.dialog.visible = true;
      this._id = item._id;
      this.addList = item.phone_number;
      this.getUserList();
    },
    // 获取用户列表
    updatePageShare: function () {
      let params = {};
      params._id = this._id;
      params.phone_number = this.addList;
      lib.tmsapi.post({
        api: 'api/test/page/share',
        data: params,
        success: (res) => {
          if (res.data) {
            this.userList = res.data || [];
          }
        },
      })

    },
    // 获取用户列表
    getUserList: function () {
      let params = {};
      params.nickname = this.formInline.nickname;
      params.phoneNumber = this.formInline.phoneNumber;
      lib.tmsapi.get({
        api: 'api/test/user/users',
        data: params,
        success: (res) => {
          if (res.data) {
            this.userList = res.data || [];
          }
        },
      })

    },

    handleChange(val, even) {
      if (val && val.length) {
        let index = val[val.length - 1];
        this.seleIndex = index;
        this.$emit('handleChange', val, index);
      }
    },
    handleCurrentChange(val) {
      this.$emit('handleCurrentChange', val);
    },
    // 删除页面确认
    delConfirm(id, pIndex, gIndex) {
      this.$confirm('确定要删除页面？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
          .then(() => {
            this.$emit('delPage', id, pIndex, gIndex);
          })
          .catch(() => {
            return;
          });
    },
    // 复制页面
    copyPage(index, item, gIndex) {
      this.$emit('copyPage', index, item, gIndex);
    },
    // 搜索页面
    searchPage() {
      this.$emit('searchPage', this.name_like);
    },

    // 新建页面
    addPage(gIndex) {
      this.$emit('addPage', gIndex);
      this.checked = false;
      this.pageList.forEach(element => {
        element.isSelect = false;
      });
    },
    changePage(pIndex, gIndex) {
      this.$emit('changePage', pIndex, gIndex);
    },
    //单选页面
    choose(index) {
      this.$emit('choose', index);
      var checked = true;
      this.pageList.forEach(element => {
        if (!element.isSelect) {
          checked = false;
        }
      });
      this.checked = checked;
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-tips{
  padding-bottom: 20px;
  color: #e77d7d;
}
.dialog-content{
  height: 450px;
  overflow-y: scroll;
}
.dialog-select{
  padding-bottom: 10px;
}

.search-wrapper {
  padding: 10px 5% 0;
}

.add-page {
  width: 90%;
  margin: 16px auto;
  background: #F6F9FE;
  border: 1px solid #4A8EF7;
  color: #4A8EF7;
}

.header-title {
  margin-left: 10px;
}

.header-icon {
  margin-left: 5px;
}

.page-list {
  width: 224px;
  overflow-y: auto;
  height: 670px;
  // padding-top: 20px;
  overflow-x: hidden;

  .page-item {
    display: flex;
    align-items: center;
    min-height: 50px;
    box-shadow: inset 0 -1px 0 0 #ebeef5;
    padding: 0 10px 0 10px;
    font-size: 12px;
    cursor: pointer;
    position: relative;
    width: 100%;

    .un-publish {
      position: absolute;
      top: 0;
      left: 0;
      width: 4px;
      height: 100%;
      background: #f5a623;
    }

    &:first-child {
      box-shadow: inset 0 -1px 0 0 #ebeef5, inset 0 1px 0 0 #ebeef5;
    }

    .choose {
      width: 15px;
      height: 15px;
      margin-right: 5px;
      background: url('https://img.mockuai.com/tms/2018/7/19/upload_aee3be34249ae99a58920cd1b6940d98.png');
      background-size: 100%;
      box-sizing: border-box;
    }

    .unchoose {
      width: 15px;
      height: 15px;
      border-radius: 100%;
      margin-right: 5px;
      border: 1px solid #d5d5d5;
      background: transparent;
      box-sizing: border-box;
    }

    .index {
      background: #4a8ef7;
      border: 1px solid #4a8ef7;
      border-radius: 2px;
      padding: 2px 3px;
      color: #fff;
      margin-right: 5px;
    }

    &:hover,
    &.active {
      background: #f5f7fa;
    }

    .set-icon {
      text-align: right;

      i {
        border: 1px solid #4a8ef7;
        display: inline-block;
        padding: 4px;
        font-size: 10px;
        color: #4a8ef7;
        background: #fff;
        border-radius: 50%;
        margin-left: 4px;

        &:before {
          color: #4a8ef7;
        }

        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}

.editor-page-list {
  position: relative;
}

.add-template {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0px;
  left: 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 15px;
  background: white;
}

.tip {
  font-size: 12px;
  color: #ffffff;

  &:before {
    content: '';
    width: 6px;
    height: 6px;
    display: inline-block;
    background: #f5a623;
    border-radius: 50%;
    vertical-align: middle;
    margin-right: 5px;
  }

  span {
    display: inline-block;
    vertical-align: middle;
  }
}
</style>
